import { render, staticRenderFns } from "./PushList.vue?vue&type=template&id=0479b866&scoped=true"
import script from "./PushList.vue?vue&type=script&lang=js"
export * from "./PushList.vue?vue&type=script&lang=js"
import style0 from "./PushList.vue?vue&type=style&index=0&id=0479b866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0479b866",
  null
  
)

export default component.exports